// Notifications.jsx
import React from 'react';
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { FaCalendarAlt } from "react-icons/fa";
import { MdNotificationsActive } from "react-icons/md";
import { baseUrl } from '../config';



const Notifications = () => {
  return (
    <div id="notificationBase">
      <div className="notification-header">
        <h6>Notifications</h6>
        <span className="notification-count">3 new</span>
      </div>
      
      <div className="notification-list">
        <div className="notificationWrapper unread">
          <div className="notification">
            <div className="notification-icon">
              <MdNotificationsActive />
            </div>
            <div className="notification-content">
              <p className="notification-text"><strong>Budget Approved</strong> - Your production budget has been approved.</p>
              <span className="notification-time">Just now</span>
            </div>
          </div>
        </div>
        
        <div className="notificationWrapper unread">
          <div className="notification">
            <div className="notification-icon">
              <FaCalendarAlt />
            </div>
            <div className="notification-content">
              <p className="notification-text">Reminder: Call sheet for Scene 12 is due tomorrow</p>
              <span className="notification-time">30 minutes ago</span>
            </div>
          </div>
        </div>
        
        <div className="notificationWrapper">
          <div className="notification">
            <div className="notification-icon">
              <IoCheckmarkDoneCircle />
            </div>
            <div className="notification-content">
              <p className="notification-text">Location "Downtown Cafe" has been secured for filming</p>
              <span className="notification-time">Yesterday</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="notification-footer">
        <a href="/notifications">View All Notifications</a>
        <a href="/notifications/settings">Settings</a>
      </div>
    </div>
  );
};

export default Notifications;
